"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppEnvConfig = void 0;
const getInfraStageFromDomain_1 = require("./utils/helpers/getInfraStageFromDomain");
const commonConfig = {
    WHATSAPP_BASE_URL: 'https://api.whatsapp.com',
};
const commonConfigByEnv = {
    homologation: {
        AUTH_CUSTOMER_API_URL: 'https://hauth.vd.grupoboticario.com.br',
        NODE_ENV: 'homologation',
        REACT_APP_API: 'https://hminhaloja-api.grupoboticario.digital',
    },
    production: {
        AUTH_CUSTOMER_API_URL: 'https://auth.vd.grupoboticario.com.br',
        NODE_ENV: 'production',
        REACT_APP_API: 'https://minhaloja-api.grupoboticario.digital',
    },
};
class AppEnvConfig {
    static getConfig() {
        const environment = (0, getInfraStageFromDomain_1.getInfraStageFromDomain)();
        return Object.assign(Object.assign({}, commonConfig), commonConfigByEnv[environment]);
    }
}
exports.AppEnvConfig = AppEnvConfig;
